
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  menuRequisition: [],
  mealCountData: [],
  isexcluded: false,
  ishybrid: false,
  deliverydate: {},
  revenueInfo: {
    revenuePerDay: null,
    theoPerDay: null,
    ispublished: false,
  },
  loading: false,
  daypartLoading: false,
  error: null,
};



export const getMenuRequisition = createAsyncThunk(
  'menuRequisition/GetMenuRequisition',
  async (payload: any) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetMenuRequisition`, payload);
    return response?.data?.data;
  }
);
export const getMenuRequisitionDaypart = createAsyncThunk(
  'menuRequisition/GetMenuRequisitionDaypart',
  async (payload: any) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetMenuRequisition`, payload);
    return response?.data?.data;
  }
);

export const getMenuRequisitionCombo = createAsyncThunk(
  'MenuProjection/fetchInitiateMenuPlanCombo',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetComboMenuRequisition`, payload);
    return response?.data?.data;
  }
);
export const getMenuRequisitionComboDaypart = createAsyncThunk(
  'MenuProjection/fetchInitiateMenuPlanComboDaypart',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetComboMenuRequisition`, payload);
    return response?.data?.data;
  }
);

export const getMenuRequisitionFoodProgram = createAsyncThunk(
  'MenuProjection/GetFoodProgramMenuRequisition',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetFoodProgramMenuRequisition`, payload);
    return response?.data?.data;
  }
);
export const getMenuRequisitionFoodProgramDaypart = createAsyncThunk(
  'MenuProjection/GetFoodProgramMenuRequisitionDaypart',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetFoodProgramMenuRequisition`, payload);
    return response?.data?.data;
  }
);

export const fetchRevenueInfo = createAsyncThunk(
  'MenuRequisition/GetRevenuePerDayValue',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetRevenuePerDayValue`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuRequisitionMealCount = createAsyncThunk(
  'MenuRequisition/GetMenuRequisitionMealCount',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuRequisition/GetMenuRequisitionMealCount`, payload);
    return response?.data?.data;
  }
);

const menuRequisitionSlice = createSlice({
  name: 'menuRequisition',
  initialState,
  reducers: {
    updateRevenuePerDay: (state, action) => {
      state.revenueInfo.revenuePerDay = action.payload;
    },
    resetState: () => initialState, // Reset state to initial values
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMenuRequisition.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMenuRequisition.fulfilled, (state, action) => {
        state.loading = false;
        state.menuRequisition = action.payload.daypartmenulist;
        state.isexcluded = action.payload.isexcluded;
        state.ishybrid = action.payload.ishybrid ?? false;
      })
      .addCase(getMenuRequisition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    //update only daypart
    builder
      .addCase(getMenuRequisitionDaypart.pending, (state) => {
        state.daypartLoading = true;
      })
      .addCase(getMenuRequisitionDaypart.fulfilled, (state, action) => {
        const updatedDaypart = action.payload.daypartmenulist[0];
        state.menuRequisition = state.menuRequisition.map((plan: any) =>
          plan.daypartcode === updatedDaypart.daypartcode
            ? { ...plan, ...updatedDaypart } // Update matching object
            : plan // Keep unchanged objects
        );
        state.daypartLoading = false;
      })
      .addCase(getMenuRequisitionDaypart.rejected, (state) => {
        state.daypartLoading = false;
      });

    builder
      .addCase(getMenuRequisitionFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMenuRequisitionFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.menuRequisition = action.payload.daypartmenulist;
        state.isexcluded = action.payload.isexcluded;
        state.ishybrid = action.payload.ishybrid ?? false;
      })
      .addCase(getMenuRequisitionFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    //update only daypart
    builder
      .addCase(getMenuRequisitionFoodProgramDaypart.pending, (state) => {
        state.daypartLoading = true;
      })
      .addCase(getMenuRequisitionFoodProgramDaypart.fulfilled, (state, action) => {
        const updatedDaypart = action.payload.daypartmenulist[0];
        state.menuRequisition = state.menuRequisition.map((plan: any) =>
          plan.daypartcode === updatedDaypart.daypartcode
            ? { ...plan, ...updatedDaypart } // Update matching object
            : plan // Keep unchanged objects
        );
        state.daypartLoading = false;
      })
      .addCase(getMenuRequisitionFoodProgramDaypart.rejected, (state) => {
        state.daypartLoading = false;
      });

    builder
      .addCase(getMenuRequisitionCombo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMenuRequisitionCombo.fulfilled, (state, action) => {
        state.loading = false;
        state.menuRequisition = action.payload.daypartmenulist;
        state.isexcluded = action.payload.isexcluded;
        state.ishybrid = action.payload.ishybrid ?? false;
      })
      .addCase(getMenuRequisitionCombo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    //update only daypart
    builder
      .addCase(getMenuRequisitionComboDaypart.pending, (state) => {
        state.daypartLoading = true;
      })
      .addCase(getMenuRequisitionComboDaypart.fulfilled, (state, action) => {
        const updatedDaypart = action.payload.daypartmenulist[0];
        state.menuRequisition = state.menuRequisition.map((plan: any) =>
          plan.daypartcode === updatedDaypart.daypartcode
            ? { ...plan, ...updatedDaypart } // Update matching object
            : plan // Keep unchanged objects
        );
        state.daypartLoading = false;
      })
      .addCase(getMenuRequisitionComboDaypart.rejected, (state, action) => {
        state.daypartLoading = false;
      });

    builder
      .addCase(fetchRevenueInfo.fulfilled, (state, action) => {
        // state.loading = false;
        state.revenueInfo.revenuePerDay = action.payload.revenueperday;
        state.revenueInfo.theoPerDay = action.payload.theocost;
        state.revenueInfo.ispublished = action.payload.ispublished;
      })
      .addCase(fetchRevenueInfo.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.error.message;
      });

        //meal count
       builder
      .addCase(fetchMenuRequisitionMealCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuRequisitionMealCount.fulfilled, (state, action) => {
        state.loading = false;
        // Write to dedicated field so Regular's fulfilled handler never overwrites this
        state.mealCountData = action.payload.mealtypelist;
        // Preserve existing isexcluded if MealCount API doesn't return it
        state.isexcluded = action.payload.isexcluded ?? state.isexcluded;
      })
      .addCase(fetchMenuRequisitionMealCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

  },
});

export const { updateRevenuePerDay, resetState } = menuRequisitionSlice.actions;
export default menuRequisitionSlice.reducer;
